module.exports = __webpack_public_path__ + "static/media/shopping.9ebee9a1.jpg";